import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchTypesLogicService } from './logic/branch-types/branch-types-logic.service';
import { BranchTypesService } from './logic/branch-types.service';
import { BranchTypesDaoService } from './dao/branch-types-dao.service';
import { BranchTypesDbDaoService } from './dao/branch-types-dao/branch-types-db-dao.service';
import { LocalBranchTypesDbTableDefinition } from './dao/branch-types-dao/local-branch-types-db-table-definition';
import { BranchTypesDbTableDefinition } from './dao/branch-types-dao/branch-types-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: BranchTypesService, useClass: BranchTypesLogicService },
    { provide: BranchTypesDaoService, useClass: BranchTypesDbDaoService },
    { provide: BranchTypesDbTableDefinition },
    { provide: LocalBranchTypesDbTableDefinition },
  ]
})
export class BranchTypesModule {}
